import React, {useState, useEffect} from 'react';
import NavigationBar from '../../../../Components/Nav/NavigationBar';
import { useCarrito } from '../../../Carrito/CarritoContext';
import { Container, Row, Col, Toast} from 'react-bootstrap';
import igorInnicio from '../../../../assets/Productos/igor/Fotos/Igor_foto_inicio.webp';
import igorIMG from '../../../../assets/carrito/Igor.webp';
import usos from '../../../../assets/Productos/uriel_y_polo/Fotos/usos.png';
import vista from '../../../../assets/Productos/igor/Señalización_materialidad/Igor_Señalizacion materialidad.webp';
import dimensiones from '../../../../assets/Productos/igor/Dimensiones/Igor_dimensiones.webp';
import foto1 from '../../../../assets/Productos/igor/Fotos/Igor_izquierda.webp';
import foto2 from '../../../../assets/Productos/igor/Fotos/Igor_derecha.webp';
import config1 from '../../../../assets/Productos/igor/Configuraciones/Igor_configuracion_1.webp';
import config2 from '../../../../assets/Productos/igor/Configuraciones/Igor_configuracion_2.webp';
import final from '../../../../assets/Productos/igor/Fotos/Igor_inferior.webp';
import GaleryIgor from '../../../../Components/CarrouselProductos/IgorCarrousel/GaleryIgor';
import Footer from '../../../../Components/Footer/Footer';
import stripe_logo from '../../../../assets/img/stripe_logo.webp';
import logoToast from '../../../../assets/logo/LogoDiagrama.png';
import './igor.css';

const Igor = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const StripeIgor = () => {
    window.location.href = 'https://buy.stripe.com/3csdQZ6Bx9SHfM46ow';
  };

  const { actualizarCarrito } = useCarrito();
  const [showToast, setShowToast] = useState(false);

  const IgorProducto = () => {
    actualizarCarrito((carritoActual) => {
    const nuevoProducto = {
      imagen: igorIMG,
      id: "price_1O2fIZDyGma9TCw9zC6lK1kw",
      nombre: 'Herminio',
      preciounit: 40489,
      precio: 40489,
      cantidad: 1,
    };

    const productoExistente = carritoActual.find((producto) => producto.id === nuevoProducto.id);

    if (productoExistente) {
      productoExistente.cantidad += 1;
    } else {
      carritoActual.push(nuevoProducto);
    }
    setShowToast(true);
    return [...carritoActual];
  });
};

  return (
      <>
      <NavigationBar/>
      <div className='container-fluid'>
      <section>
          <div className='row pt-3'>

            <div className='col-sm-6 col-md-6 col-lg-6'>
              <img src={igorInnicio} alt="" className='imagen' />
            </div>

            <div className='col-sm-6 col-md-6 col-lg-6 d-flex flex-column justify-content-center align-items-center'>
              <div className='text-start m-3'>
                <h2>IGOR_</h2>
                <p>Macetero, creado para ambientar y dividir espacios interiores o exteriores. Cuenta con la posibilidad de conjugar color y materialidad en medio de composiciones vegetales y dirigir plantas colgantes, trepadoras que mejoran la calidad del aire que respiramos.</p>
                {/* <h2 className='pt-3'>$40,489.00</h2> */}

                <div className='col-sm-6 col-md-6 col-lg-8 justify-content-start'>
                <img src={usos} alt="" className='imagen' />
              </div>

              <div className='text-start'>
                {/* <button className='elementor-button-clara' onClick={IgorProducto}>Agregar al Carrito</button>
                <br />
                <p className='pt-3'><button className='elementor-button-clara' onClick={StripeIgor}>Comprar</button></p> */}
              </div>
              </div>

              <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide className='color-toast'>
        <div className=''>
          <img src={logoToast} className="rounded me-2 imgToast" alt="" />
          <b>Producto Añadido al Carrito</b>
          </div>
        </Toast>

            </div>
          </div>
        </section>

        <GaleryIgor/>

        <div className='contenedorIMG'>
          <img src={vista} alt="" className='homeImg' />
        </div>

        <div className='contenedorIMG'>
          <img src={dimensiones} alt="" className='homeImg' />
        </div>

        <Container fluid className="pt-5">
          <div className="row">
            <div className='col-sm-12 col-md-6 col-lg-6 m-0'><img src={foto1} alt="" className='imagenjunta1' /></div>
            <div className='col-sm-12 col-md-6 col-lg-6 m-0 pt-2'> <img src={foto2} alt="" className='imagenjunta2' /></div>
          </div>
          <h2 className='text-center pt-3'>Posibles configuraciones y usos</h2>
        </Container>

        <div className='contenedorIMG'>
          <img src={config1} alt="" className='homeImg' />
        </div>

        <div className='contenedorIMG'>
          <img src={config2} alt="" className='homeImg' />
        </div>

        <div className='contenedorIMG'>
          <img src={final} alt="" className='homeImg' />
        </div>

      </div>
      <Footer/>
      </>
  );
}

export default Igor;